export default __webpack_public_path__ + "static/media/GuideCv2.31714e28.jpg";